import { AudioPlayerSkeleton } from "@circle-react-shared/MediaPlayer/AudioPlayer/AudioPlayerSkeleton";
import { lazyWithRetry } from "@circle-react/helpers/lazyRetry";
import { Suspense } from "react";

import type { AudioPlayerProps } from "./index";

const AudioPlayer = lazyWithRetry(() =>
  import(/* webpackChunkName: "EditorContentAudioPlayer" */ "./index").then(
    module => ({ default: module.AudioPlayer }),
  ),
);

/** Keeps media-chrome / MediaPlayer audio off the initial shell graph. */
export const LazyAudioPlayer = (props: AudioPlayerProps) => (
  <Suspense fallback={<AudioPlayerSkeleton className="max-w-[640px]" />}>
    <AudioPlayer {...props} />
  </Suspense>
);
